import React, { Component } from "react";
import { withRouterUtilities } from "../util/withRouterUtilities";
import CenteredPaper from "../layouts/CenteredPaper";
import { contentMap } from "../content/contentMap";
import { customNavigationMap } from "../config/customNavigationMap";
import ChoiceButtons from "../molecules/ChoiceButtons";
import Titles from "../molecules/Titles";
import UswfList from "../molecules/UswfList";
import { Calculator } from "../molecules/Calculator";
import ILearn from "../molecules/ILearn";
import StatusCheck from "../components/StatusCheck";

class RefinanceCashOutCalculatorPage extends Component {
  render() {
    const content = contentMap.RefinanceCashOutCalculatorPage;
    const navigationsAway = customNavigationMap.RefinanceCashOutCalculatorPage;

    return (
      <div className="page-wrapper">
        <StatusCheck />
        <ILearn content={content}>
          <CenteredPaper>
            <Titles content={content} />
            <UswfList content={content} />
            <Calculator type="MortgageRefinance" />
            <ChoiceButtons
              content={content}
              navigationsAway={navigationsAway}
              navigate={this.props.navigate}
            />
          </CenteredPaper>
        </ILearn>
      </div>
    );
  }
}

export default withRouterUtilities(RefinanceCashOutCalculatorPage);
